<script setup lang="ts">
import { ref, onMounted } from "vue";
import { getLayoutContent, type LayoutContent } from "@/helpers/apiDashboardWrappers";

const layoutContent = ref<LayoutContent>();

onMounted(async () => {
  try {
    layoutContent.value = await getLayoutContent("footer");

    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.altium.com/shared/navigation_new/app/dist_external_site_server_html/footer.js';
    script.async = true;
    document.body.appendChild(script);
  }
  catch (error) {
    console.error(error);
  }
});
</script>

<template>
  <div v-if="layoutContent?.success && layoutContent.data" v-html="layoutContent.data" class="footer-v2"
    :data-ua_server="layoutContent.dataServer" :data-profile_server="layoutContent.dataServerProfile"
    id="altium-navigation-footer">
  </div>
</template>
